import { render } from "./payment-details.vue?vue&type=template&id=67731afe"
import script from "./payment-details.vue?vue&type=script&lang=js"
export * from "./payment-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__